/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Report_Desc6Inputs */

const en_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What shipped, what broke, what is next, in one readable page.`)
};

const ar_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما أُطلق وما تعطل وما التالي، في صفحة واحدة مقروءة.`)
};

const bn_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী এসেছে, কী ভেঙেছে, এরপর কী, এক পাঠযোগ্য পৃষ্ঠায়।`)
};

const de_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was geliefert, was kaputt, was als Nächstes kommt, auf einer lesbaren Seite.`)
};

const es_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué se entregó, qué se rompió, qué sigue, en una página legible.`)
};

const fr_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qui est livré, ce qui est cassé, la suite, sur une page lisible.`)
};

const pt_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que foi entregue, o que quebrou, o que vem a seguir, numa página legível.`)
};

const zh_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交付了什么、坏了什么、下一步是什么，一页讲清。`)
};

const tr_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne çıktı, ne bozuldu, sırada ne var, tek okunur sayfada.`)
};

const ru_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что вышло, что сломалось, что дальше, на одной читаемой странице.`)
};

const pl_svc_retainer_report_desc6 = /** @type {(inputs: Svc_Retainer_Report_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co dowiezione, co zepsute, co dalej, na jednej czytelnej stronie.`)
};

/**
* | output |
* | --- |
* | "What shipped, what broke, what is next, in one readable page." |
*
* @param {Svc_Retainer_Report_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_report_desc6 = /** @type {((inputs?: Svc_Retainer_Report_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Report_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_report_desc6(inputs)
	if (locale === "bn") return bn_svc_retainer_report_desc6(inputs)
	if (locale === "de") return de_svc_retainer_report_desc6(inputs)
	if (locale === "es") return es_svc_retainer_report_desc6(inputs)
	if (locale === "fr") return fr_svc_retainer_report_desc6(inputs)
	if (locale === "pt") return pt_svc_retainer_report_desc6(inputs)
	if (locale === "zh") return zh_svc_retainer_report_desc6(inputs)
	if (locale === "tr") return tr_svc_retainer_report_desc6(inputs)
	if (locale === "ru") return ru_svc_retainer_report_desc6(inputs)
	if (locale === "pl") return pl_svc_retainer_report_desc6(inputs)
	return en_svc_retainer_report_desc6(inputs)
});
export { svc_retainer_report_desc6 as "svc_retainer_REPORT_desc" }